import { render, staticRenderFns } from "./death.vue?vue&type=template&id=ae7664b0&scoped=true&"
import script from "./death.vue?vue&type=script&lang=js&"
export * from "./death.vue?vue&type=script&lang=js&"
import style0 from "./death.vue?vue&type=style&index=0&id=ae7664b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7664b0",
  null
  
)

export default component.exports